import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'

class OrgStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            orgs: [],
            filteredOrgs: [],
            orgIds: [],
	    selectedOrg: undefined,
            operation: undefined
        });
    }
    
	loadAllOrgs = () => {
		axios.get('/api/v1/query/org').then(({ data }) => {
			this.loading = false;
			this.orgs = data;
			this.filteredOrgs = data;
		});
	}


    onSubmit = () => {
        const { orgName } = this;

        this.loading = true;
        this.orgs = [];

        axios.get('/api/v1/org/orgs').then( ({data}) => {
           console.log('get org data from org master 2')
            this.loading = false
            this.orgs = data
        });
    }


    setSearch = action((val) => {
       // console.log(val)

        this.filteredOrgs = this.orgs.filter(i => i.orgname.indexOf(val) > -1);
    })



    creOrg = () => {
        //console.log('Cre org call in org-store');

        if ((this.selectedOrg.orgname === null) || (this.selectedOrg.orgname ==="") || (this.selectedOrg.orgname===undefined)) {
          alert('Org Name cannot be null, please enter a name');
          return false;
        } 

       
        axios.post('/api/v1/org/create', {
            org: this.selectedOrg
          })
           .then((response) => {
                                this.loadAllOrgs();
                                eb.emit('toast', {
                                        status: 'success',
                                        text: 'Org created'
                                })
                                eb.emit('org-created');
                        }); 

      }

    updOrg = () => {
        axios.post('/api/v1/org/update', {
            org: this.selectedOrg
          })
           .then((response) => {
                                this.loadAllOrgs();
                                eb.emit('toast', {
                                        status: 'success',
                                        text: 'Org updated'
                                })
                                eb.emit('org-updated');
                        });

      }

        loadOrg = (orgId) => {

        axios.get(`/api/v1/org/${orgId}`).then( ({data}) => {
            this.loading = false;
            this.selectedOrg = data;
        });
       }

    setOrgName = action((val) => {
        console.log(val)
        this.selectedOrg.orgname = val;
    })

    setLegalName = action((val) => {
        //console.log(val)
        this.selectedOrg.legalname = val;
    })

    setBusinessType = action((val) => {
        //console.log(val)
        this.selectedOrg.businesstype = val;
    })

    setOrgRoleType = action((val) => {
        console.log(val)
        this.selectedOrg.orgroletype = val;
    })

    setCreditRating = action((val) => {
       // console.log(val)
        this.selectedOrg.creditrating = val;
    })

    setOrganizationNumber = action((val) => {
        //console.log(val)
        this.selectedOrg.organizationnumber = val;
    })

    setNumberOfEmployees = action((val) => {
        //console.log(val)
        this.selectedOrg.numberofemployees = val;
    })

    setDunsNumber = action((val) => {
        //console.log(val)
        this.selectedOrg.dunsnumber = val;
    })

    setYearEstablished = action((val) => {
        //console.log(val)
        this.selectedOrg.yearestablished = val;
    })

    setActiveFlag = action((val) => {
        //console.log(val)
        this.selectedOrg.activeflag = val;
    })

}

const orgstore = new OrgStore();
export default orgstore;



// WEBPACK FOOTER //
// ./src/store/org-store.js